// Copy text to the clipboard and resolve true only if it really was copied.
// Tries the async Clipboard API first; where that's blocked (some web views,
// unfocused documents, older browsers) falls back to a hidden textarea +
// execCommand('copy').
export async function copyText(text) {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch { /* clipboard API blocked — fall back below */ }
  const ta = document.createElement('textarea');
  ta.value = text;
  ta.setAttribute('readonly', '');
  ta.style.position = 'fixed';
  ta.style.opacity = '0';
  document.body.appendChild(ta);
  ta.select();
  let copied = false;
  try { copied = document.execCommand('copy'); } catch { copied = false; }
  document.body.removeChild(ta);
  return copied;
}
